import { useEffect, useCallback } from 'react'

// Fly-to-region handler, registered up to the parent (App) so the sidebar /
// command palette / URL ?region= can recenter the map. Uses the pre-calculated
// centroid for an O(1) lookup.
export function useCenterToRegion(map, regionsData, onCenterToRegion) {
  const handleCenter = useCallback((region) => {
    if (!region || !map.current) return
    if (Array.isArray(region.coordinates) && region.coordinates.length >= 2) {
      map.current.flyTo({ center: region.coordinates, zoom: 8, duration: 1500 })
      return
    }
    if (!regionsData) return
    const feature = regionsData.features.find((f) => f.properties.region_id === region.region_id)
    if (feature && feature.properties._centroid) {
      map.current.flyTo({
        center: feature.properties._centroid,
        zoom: 6,
        duration: 1500,
      })
    }
  }, [map, regionsData])

  useEffect(() => {
    if (onCenterToRegion) onCenterToRegion(handleCenter)
  }, [handleCenter, onCenterToRegion])

  return handleCenter
}
